<template>
    <tr v-for="row in rows" :key="'skeleton_' + row" class="table-skeleton-row">
        <td v-for="column in columns" :key="'skeleton_' + row + '_' + column">
            <span class="table-skeleton-bar" :style="{ width: barWidth(row, column) }"></span>
        </td>
    </tr>
</template>

<script setup>
defineProps({
    rows: {
        type: Number,
        default: 5
    },
    columns: {
        type: Number,
        default: 6
    }
})

const barWidth = (row, column) => (45 + ((row * 7 + column * 13) % 45)) + '%'
</script>

<style scoped>
.table-skeleton-row td {
    padding: 16px 14px;
    border-bottom: 1px solid #f2f4f7;
}
.table-skeleton-bar {
    display: block;
    height: 12px;
    border-radius: 6px;
    background: linear-gradient(90deg, #f2f4f7 25%, #e4e7ec 37%, #f2f4f7 63%);
    background-size: 400% 100%;
    animation: table-skeleton-shimmer 1.4s ease infinite;
}
@keyframes table-skeleton-shimmer {
    0% {
        background-position: 100% 50%;
    }
    100% {
        background-position: 0 50%;
    }
}
</style>
